import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from './auth';

export const authGuard: CanActivateFn = () => {
  // SSR：服务端无 localStorage，无法判定登录态。放行交给客户端 hydrate 后再判，
  // 否则刷新时服务端会因读不到 token 误判未登录并重定向到 /login。
  if (isPlatformServer(inject(PLATFORM_ID))) {
    return true;
  }
  const auth = inject(Auth);
  const router = inject(Router);
  if (auth.isAuthenticated()) {
    return true;
  }
  router.navigate(['/login']);
  return false;
};
